import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserResponse } from "../../auth/_models/UserResponse";
import { HomeService } from "../../service/home/home.service";
import { ImpostoRendaService } from '../../service/Imposto-renda-service/imposto-renda.service';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { AutorizacaoDeAcessoService } from "../../service/autorizacao-de-acesso/autorizacao-de-acesso.service";
import { Observable } from "rxjs";
import { CampanhasService } from "../../service/campanhas/campanhas.service";
import { UsuarioPerfilDTO } from "../../model/dadosServidorBensValores.dto";
import { CampanhasServidorService } from "../../service/campanha-servidor/campanhas-servidor.service";
import { VerificaCampanhaResponseDto } from "../../model/verificaCampanhaResponseDto";
import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { AnexoBenseValores } from "../../model/anexoBenseValores";
import { AuthenticationService } from "../../auth/_services";
import { PosCampanhaService } from "../../service/posCampanha/pos-campanha.service";
import { ServidorService } from "../../service/servidor/servidor.service";
import { Identity } from "../../auth/_models/identity";
import { MatriculaUtil } from "../../utils/matricula-util";

@Component({
  selector: 'app-bens-valores',
  templateUrl: './bens-valores.component.html',
  styleUrls: ['./bens-valores.component.sass']
})
export class BensValoresComponent implements OnInit {
  openScreen: number = 1;
  isInfoImportantVisible: boolean = true;
  selectedYear: number;
  arquivoSelecionado: File;
  arquivoSelecionadoIr: File;
  isChecked: boolean = false;
  user: UserResponse = null;
  verificaCampanhaResponseDto: VerificaCampanhaResponseDto = new VerificaCampanhaResponseDto();
  isLoading: boolean = false;
  tituloCampanhaVigente: string;
  usuarioPerfilDTO: UsuarioPerfilDTO;

  displayedColumns: string[] = ['ano','declaracaoIR', 'comprovante'];
  dataSource: MatTableDataSource<AnexoBenseValores>;
  totalElements: number = 0;
  pageSize: number = 5;
  pageIndex: number = 0;
  msgDeEncerramento: boolean;
  optionsServidor: any[] = [];
  filteredOptionsServidor: any[] = [];

  servidor: string = null;
  infoAuthentication: Identity;

  nextPage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    let matriculaSearch = MatriculaUtil.extrairMatriculaString(this.servidor)
    matriculaSearch != this.user.matricula ? this.listarAnexosOutrosUsuario(event.pageIndex, event.pageSize, matriculaSearch) : this.getListaAnexos(event.pageIndex, event.pageSize);
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  openScreenOne() {
    this.openScreen = 1;
    this.isInfoImportantVisible = true;
  }
  openScreenTwo() {
    this.openScreen = 2;
    this.isInfoImportantVisible = true;
  }

  openScreenThree() {
    this.openScreen = 3;
    this.isInfoImportantVisible = true;
    this.getListaAnexos(this.pageIndex, this.pageSize);
  }

  onCheckboxChange(isSelect: boolean) {
    this.isChecked = isSelect;
  }

  onArquivoSelecionadoIr(event: any) {
    if(event.target.files[0].size <= 1024 * 1024 * 10){
      if(event.target.files[0].type !== "application/pdf"){
        this.toasterService.warning('Somente é permitido arquivos PDF');
      } else {
        this.arquivoSelecionadoIr = event.target.files[0];
      }
    } else{
      this.toasterService.warning('Atenção: O arquivo anexado excede o tamanho máximo permitido de 10 MB');
    }
  }

  enviarAnexo() {
    if (this.arquivoSelecionadoIr) {
      this.isLoading = true;
      if (this.arquivoSelecionadoIr.type === 'application/pdf') {
        this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
        // O arquivo selecionado é um PDF
        // Faça o processamento adicional ou envie para o servidor
      }
      this.impostoRendaService.uploadComprovanteIR(this.selectedYear, this.arquivoSelecionadoIr).subscribe(
        (response) => {
          this.isLoading = false;
          this.toasterService.success('Arquivo enviado');
          this.isLoading = false;
          this.verificarCampanha();
        },
        (error) => {
          if (error.status == 406) {
            this.toasterService.warning('Somente é permitido arquivos PDF');
          } if (error.status == 422) {
            this.toasterService.warning('Somente é permitido arquivos PDF');
          } else {
            this.toasterService.error('Erro ao enviar o anexo');
          }
          this.onArquivoExcluidoIr()
          this.isLoading = false;
        }
      ), error => {
        this.toasterService.error(error.error.message);
      };
    }
  }

  onArquivoExcluidoIr() {
    this.arquivoSelecionadoIr = null;
    const input = document.getElementById('input-file-ir') as HTMLInputElement;
    input.value = '';
  }

  onArquivoExcluido() {
    this.arquivoSelecionado = null;
    const input = document.getElementById('input-file') as HTMLInputElement;
    input.value = '';
  }
  baixarReciboArquivoDeclaracao(id: number): void {
    let matriculaSearch = MatriculaUtil.extrairMatriculaString(this.servidor);
    if(matriculaSearch != this.user.matricula){
      this.impostoRendaService.downloadComprovanteDeclaracaoOutroUsuario(id, matriculaSearch).subscribe((response: Blob) => {
        const fileName = 'Recibo Declação IRRF.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.warning('Erro ao fazer o download do arquivo');
      });
    } else {
      this.impostoRendaService.downloadComprovanteDeclaracao(id).subscribe((response: Blob) => {
        const fileName = 'Recibo Declação IRRF.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.warning('Erro ao fazer o download do arquivo');
      });
    }
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso');
  }

  submitAuthorization(): void {
    this.autorizacaoDeAcessoService.submitAuthorization(this.isChecked).subscribe(response => {
      this.toasterService.success('Autorização enviada com sucesso!');
      this.verificarCampanha();
    }, error => {
      this.toasterService.error(error.error.message);
    });
  }

  baixarReciboArquivoAutorizacao(id: number): void {
    let matriculaSearch = MatriculaUtil.extrairMatriculaString(this.servidor);
    if(matriculaSearch != this.user.matricula){
      this.impostoRendaService.downloadReciboArquivoAutorizacaoOutroUsuario(id, matriculaSearch).subscribe((response: Blob) => {
        const fileName = 'Recibo Autorização.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.error(error.error.message);
      });
    } else{
      this.impostoRendaService.downloadReciboArquivoAutorizacao(id).subscribe((response: Blob) => {
        const fileName = 'Recibo Autorização.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.error(error.error.message);
      });
    }
  }

  baixarDeclaracao(ano: number): void {
    let matriculaSearch = MatriculaUtil.extrairMatriculaString(this.servidor)
    if(matriculaSearch != this.user.matricula){
      this.impostoRendaService.baixarDeclaracaoOutroUsuario(ano, matriculaSearch).subscribe((response: Blob) => {
        const fileName = 'Declaração.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.error(error.error.message);
      });
    } else {
      this.impostoRendaService.baixarDeclaracao(ano).subscribe((response: Blob) => {
        const fileName = 'Declaração.pdf';
        const blob = new Blob([response], { type: 'application/octet-stream' });
        // Inicia o download do arquivo
        this.downloadFile(blob, fileName);
      }, error => {
        this.toasterService.error(error.error.message);
      });
    }
  }

  enviarFormAutorizacao() {
    if (this.arquivoSelecionado) {
      this.isLoading = true;
      if (this.arquivoSelecionado.type === 'application/pdf') {
        this.toasterService.info('Enviando arquivo. Por favor, aguarde.');
        // O arquivo selecionado é um PDF
        // Faça o processamento adicional ou envie para o servidor
      }
      let flchecked: string = this.isChecked ? 'S' : 'N';
      this.autorizacaoDeAcessoService.uploadFormAutorizacao(this.user.matricula.toString(), flchecked, this.arquivoSelecionado).subscribe(
        (response) => {
          this.toasterService.success('Arquivo enviado');
          this.onArquivoExcluido()
          this.isLoading = false;
        },
        (error) => {
          if (error.status == 406) {
            this.toasterService.warning('Somente é permitido arquivos PDF');
          } if (error.status == 422) {
            this.toasterService.warning('Somente é permitido arquivos PDF');
          } else {
            this.toasterService.error('Erro ao enviar o anexo');
          }
          this.onArquivoExcluido()
          this.isLoading = false;
        }
      ), error => {
        this.toasterService.error(error.error.message);
      };
    }
  }

  constructor(private homeService: HomeService, private campanhaServidorService: CampanhasServidorService,
    private sanitizer: DomSanitizer,
    private impostoRendaService: ImpostoRendaService,
    private autorizacaoDeAcessoService: AutorizacaoDeAcessoService,
    private toasterService: ToastrService,
    private campanhasService: CampanhasService,
    private authenticationService: AuthenticationService,
    private servidorService: ServidorService) { }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.servidor = `${this.user.matricula} - ${this.user.nome}`;
    this.initAutoCompleteServidor();
    this.verificaCampanhaResponseDto.mensagem = ""
    this.verificarCampanha();
    this.getDadosServidor();
    this.getTituloCampanhas();
  }

  private checkUserInative(): boolean {
    this.infoAuthentication = this.authenticationService.getUserAuthData();
    return this.infoAuthentication.status == 'I' ? true : false;
  }

  private verificarCampanha() {
    this.campanhaServidorService.verificarCampanhaBenseValores().subscribe(resp => {
      this.verificaCampanhaResponseDto = resp;
      this.checkUserInative() ? this.verificaCampanhaResponseDto.autorizado = false : true;
      this.checkMsg(this.verificaCampanhaResponseDto);
      this.verificaCampanhaResponseDto.mensagem.length>1 ? this.getListaAnexos(this.pageIndex, this.pageSize) : false;
    },error => {
      this.toasterService.error(error.error.message);
    })
  }

  private getDadosServidor() {
    this.homeService.getDadosServidor().subscribe(resp => {
      this.usuarioPerfilDTO = resp;
      }, error => {
      this.toasterService.error(error.error.message);
    })
  }

  private getListaAnexos(page: number, size: number) {
    this.impostoRendaService.getListaAnexos(page, size).subscribe(resp => {
        this.dataSource = new MatTableDataSource(resp.content);
        this.totalElements = resp.totalElements;
      }, error => {
      this.dataSource = new MatTableDataSource([]);
      this.toasterService.error('Erro ao buscar lista de arquivos. '+error.error.message);
      }
    );
  }

  private getTituloCampanhas() {
    this.getCampanhaBensEValoresVigente().subscribe( resp => {
      this.tituloCampanhaVigente = resp.nome;
      let arrayTitlte = resp.nome.split("- ")
      this.selectedYear = +arrayTitlte[1];
    }, error => {
      this.toasterService.error(error.error.message);
    })
  }

  private getCampanhaBensEValoresVigente(): Observable<any> {
    return this.campanhasService.getCampanhaBensEValoresVigente();
  }

  private checkMsg(verificaCampanhaResponseDto: VerificaCampanhaResponseDto) {
    verificaCampanhaResponseDto.mensagem.split(" ").filter( palavra => {
      if(palavra == 'encerrou'){
        this.msgDeEncerramento = true
      }
    })
  }

  public onOptionSelectedServidor(option: any): void {
    this.servidor = `${option.matricula} - ${option.nome}`;
    this.listarAnexosOutrosUsuario(0, this.pageSize, option.matricula);
  }

  private listarAnexosOutrosUsuario(page: number, size: number, matricula: string) {
    this.impostoRendaService.getListaAnexosOutrosUsuarios(page, size, matricula).subscribe(resp => {
        this.dataSource = new MatTableDataSource(resp.content);
        this.totalElements = resp.totalElements;
      }, error => {
        this.toasterService.error('Erro ao buscar lista de arquivos.');
      }
    );
  }

  initAutoCompleteServidor() {
   this.dataSource = new MatTableDataSource();
   this.servidor && this.servidor.length >= 3 ? this.onInputChange() : false;
  }

  onInputChange() {
    let value = this.servidor;
    if (value) {
      this.servidorService.getServidor(MatriculaUtil.extrairMatriculaString(value)).subscribe(
        (response) => {
          this.optionsServidor = response.content;
          this.filteredOptionsServidor = this.optionsServidor.filter((option) =>
            option.nome.toLowerCase().includes(value.toLowerCase()) || option.matricula.toString().includes(value.toLowerCase())
          );
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.optionsServidor = [];
      this.filteredOptionsServidor = [];
    }
  }
}
